/* eslint-disable react/jsx-props-no-spreading,react/require-default-props */
import React, { forwardRef } from 'react';
import { object } from 'prop-types';

const HeaderDrawerBackdrop = forwardRef((
  {
    styles
  }, ref) => {

  const backdropClasses = [
    /* default & small-medium screen backdrop styles */
    'sui-bg-inverse/50',
    'sui-fixed sui-flex sui-items-center sui-justify-center',
  ].join(' ');

  return (
    <div ref={ref} className={backdropClasses} style={styles} aria-hidden />
  );
});

HeaderDrawerBackdrop.displayName = 'HeaderDrawerBackdrop';

HeaderDrawerBackdrop.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  styles: object
};

export { HeaderDrawerBackdrop };
